import createIcon from '../../createIcon';

/**
 * @component @name BorderStyle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMjFIMTdWMTlIMTVWMjFaTTE5IDIxSDIxVjE5SDE5VjIxWk03IDIxSDlWMTlIN1YyMVpNMTEgMjFIMTNWMTlIMTFWMjFaTTE5IDE3SDIxVjE1SDE5VjE3Wk0xOSAxM0gyMVYxMUgxOVYxM1pNMyAzVjIxSDVWNUgyMVYzSDNaTTE5IDlIMjFWN0gxOVY5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BorderStyle = createIcon('BorderStyle', [
  [
    'path',
    {
      d: 'M15 21H17V19H15V21ZM19 21H21V19H19V21ZM7 21H9V19H7V21ZM11 21H13V19H11V21ZM19 17H21V15H19V17ZM19 13H21V11H19V13ZM3 3V21H5V5H21V3H3ZM19 9H21V7H19V9Z',
      key: '13eena',
    },
  ],
]);

export default BorderStyle;
